export const COOKIE_NAMES = {
    TRACKING_ID: 'kazumoTrackingId',
    KAZUMO_MEDIUM: 'kazumoMedium',

    // LIS COOKIES
    COMMON_COOKIE: 'casumo_common_cookie',

    // GTM COOKIES
    FIRST_TIME_VISIT: 'fabric:gtm:firstvisit',

    // DEVTOOLS COOKIES
    SHOW_FABRIC_LOBBIES: 'fabric:feature:showFabricLobbies',
    SWITCH_INTERCOM_WITH_LIVECHAT: 'fabric:feature:switchIntercomWithLiveChat',
    BYPASS_CACHE: 'fabric:feature:bypassCache',
    MFE_LOCATION_OVERRIDES: 'fabric:feature:mfeLocationOverrides',
    BYPASS_LIS_REDIRECTION: 'fabric:feature:bypassLisRedirection',
    ENFORCE_PRODUCTION_ENV: 'fabric:feature:productionEnv',
    CF_SPINE_OVERRIDE: 'fabric:feature:cfSpineOverride',

    DEBUGGING_INFO: 'fabric:debug:info',

    // MFE Feature toggles
    SHOW_REGISTRATION_MFE: 'fabric:registration:showRegistrationMfe'
};
